// AUTO-GENERATED by tools/codegen (pnpm gen). Do not edit. Source: packages/content/src/assets/*.ts
import m0 from './assets/characters';
import m1 from './assets/fish';
import m2 from './assets/fossils';
import m3 from './assets/furniture';
import m4 from './assets/items';
import m5 from './assets/nature';
import m6 from './assets/surfaces';
import m7 from './assets/world';
export const assetModules = { characters: m0, fish: m1, fossils: m2, furniture: m3, items: m4, nature: m5, surfaces: m6, world: m7 } as const;
